const LoginEvents = function () {
    const PARAM_NAME_LOGIN_CONFLICT = 'login-conflict';
    const PARAM_NAME_LOGIN_SUCCESS = 'login-success';
    const PARAM_NAME_PASSWORD_CHANGED = 'password-changed-successfully';
    const PARAM_VALUE_SIGNIN = 1;
    const PARAM_VALUE_SIGNUP = 2;

    function _lookup() {
        let currentUrl = document.URL;
        if (currentUrl.indexOf(PARAM_NAME_LOGIN_CONFLICT) !== -1) {
            let conflictParamFound = (new URL(currentUrl)).searchParams.get(PARAM_NAME_LOGIN_CONFLICT);
            if (conflictParamFound !== null) {
                $.ajax({
                    url: vitrineUrl + '/login/conflict',
                    method: 'GET',
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        getLoginError(data);
                    },
                    error: function (jqXHR) {
                        TINK.redirectIfConflict(jqXHR);
                    }
                });

                let cleanedUrl = TINK.removeParamFromUrl(PARAM_NAME_LOGIN_CONFLICT, window.location.href);
                if (cleanedUrl !== currentUrl) {
                    window.history.pushState({}, '', cleanedUrl);
                }
            }
        }

        signInLookup(currentUrl);
    }

    function signInLookup(currentUrl) {
        if (currentUrl.indexOf(PARAM_NAME_LOGIN_SUCCESS) !== -1) {
            let loginSuccessParamFound = (new URL(currentUrl)).searchParams.get(PARAM_NAME_LOGIN_SUCCESS);
            if (loginSuccessParamFound !== null && (loginSuccessParamFound == PARAM_VALUE_SIGNIN || loginSuccessParamFound == PARAM_VALUE_SIGNUP)) {
                let queryString = window.location.search;
                let urlParams = new URLSearchParams(queryString);
                let successValue = urlParams.get(PARAM_NAME_LOGIN_SUCCESS);
                $.ajax({
                    url: vitrineUrl + '/login/success',
                    method: 'GET',
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data) {
                        sendGa4Information(successValue, data);
                    },
                    error: function (jqXHR) {
                        TINK.redirectIfConflict(jqXHR);
                    }
                });

                let cleanedUrl = TINK.removeParamFromUrl(PARAM_NAME_LOGIN_SUCCESS, window.location.href);
                if (cleanedUrl.endsWith("?")) {
                    cleanedUrl = cleanedUrl.substring(0, cleanedUrl.length - 1);
                }
                if (cleanedUrl !== currentUrl) {
                    window.history.pushState({}, '', cleanedUrl);
                }
            }
        }
    }

    function sendGa4Information(eventName, ga4LoginInformation) {
        pushDataLayerSignUpSignInValidate(
            eventName == PARAM_VALUE_SIGNIN ? "login" : "sign_up",

            ga4LoginInformation.userFidelitySegment,
            ga4LoginInformation.userEcomSegment,
            ga4LoginInformation.userLoyaltyProgram,
            ga4LoginInformation.isMetroBuyer,
            ga4LoginInformation.userId);
    }

    function getLoginError(jsonResponseValue) {
        let url = '/' + lang + '/showLoginForm';

        $.ajax({
            url: url,
            type: 'GET',
            async: false
        }).always(function (data, status, jqXHR) {
            let $data = $(data);
            $data.each(function () {
                let $item = $(this);
                 if ($item.is('#fancybox-sign-in-box-conflict')) {
                     $('#modal-sign-in-box-conflict-container').append($item.children());
                }
            });

            _handleLoginError(jsonResponseValue);
        });
    }

    function _handleLoginError(jsonResponseValue) {
        let errorCode = jsonResponseValue.errorCode;
        let errorMessage = jsonResponseValue.errorMessage;
        let removeInProgress = true;

        switch (errorCode) {
            case 'scenario-2':
                loginScenario2Validation(jsonResponseValue);
                break;
            case 'scenario-5':
                loginScenario5Validation(jsonResponseValue);
                break;
            case 'none-intrusive-conflict':
                submitLoginAfterConflict();
                removeInProgress = false;
                break;
            default:
        }

        if (removeInProgress) {
            $('#sign-in-box').removeClass('in-progress');
        }
    }

    function submitLoginAfterConflict() {
        window.location.href = aadB2cLoginUrl;
    }

    function loginScenario2Validation(json) {
        // Setup dialog
        $('#registeredCartNumberOfItems').text(json.registeredCartQuantity);
        $('#anonymousCartNumberOfItems').text(json.anonymousCartQuantity);

        $('#confirmScenario2').click(function () {
            var data = {
                scenario: 'CART',
                accountType: $('input[type=radio][name=cartSelected2]:checked').val()
            };

            sendAjaxRequestForValidation(data).then(function () {
                submitLoginAfterConflict();
            });
        });

        showModalLoginConflicts('#scenario--2 .remodal');
    }

    function loginScenario5Validation(json) {
        // Setup dialog
        $('.sib--storeName').text(json.storeName);

        if (json.hasLoyaltyCard) {
            $('#scenario--5 .cardRelatedContent').removeClass('hide');
            $('#scenario--5 .cardRelatedContent').addClass('show');
            $('#scenario--5 .noCardRelatedContent').removeClass('show');
            $('#scenario--5 .noCardRelatedContent').addClass('hide');
        } else {
            $('#scenario--5 .cardRelatedContent').removeClass('show');
            $('#scenario--5 .cardRelatedContent').addClass('hide');
            $('#scenario--5 .noCardRelatedContent').removeClass('hide');
            $('#scenario--5 .noCardRelatedContent').addClass('show');
        }

        $('#scenario--5').html(function (index, oldHtml) {
            return oldHtml
                .replace(/\[0\]/g, json.sessionCard)
                .replace(/\[1\]/g, json.serviceCardName)
                .replace(/\[2\]/g, json.loyaltyProgramName)
                .replace(/\[3\]/g, json.notValidIn);
        });

        $('#confirmScenario5').click(function () {
            var data = {
                scenario: 'STORE_AND_LOYALTY',
                storeConflictResponse: 'YES_AND_REPLACE_STORE'
            };

            sendAjaxRequestForValidation(data).then(function () {
                submitLoginAfterConflict();
            });
        });

        $('#noScenario5').click(function () {
            var data = {
                scenario: 'STORE_AND_LOYALTY',
                storeConflictResponse: 'NO_AND_DELETE_CART'
            };

            sendAjaxRequestForValidation(data).then(function () {
                submitLoginAfterConflict();
            });
        });

        showModalLoginConflicts('#scenario--5 .remodal');
    }

    function showModalLoginConflicts(modalCurrent) {
        $(modalCurrent).remodal().open();
    }

    return {
        lookup: _lookup,
        handleLoginError: _handleLoginError
    }
}();
